module.exports = __webpack_public_path__ + "static/media/manager-b-6.cf8a212c.png";